import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccionRntService } from './accion-rnt.service';
import { TipoSolicitudEntry } from 'src/app/shared/entrys/tipo-solicitud.entry';
import { EstadosRNTEntry } from 'src/app/shared/entrys/estados-rnt-entry';
import { EstadoSolicitudEntry } from 'src/app/shared/entrys/estado-solicitud.entry';
import { ConfirmarRespuestaType, ConfirmarRespuestaModel } from 'src/app/shared/models/confirmar-respuesta.model';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';

@Component({
	selector: 'app-accion-rnt',
	templateUrl: './accion-rnt.component.html',
	styleUrls: ['./accion-rnt.component.scss']
})
export class AccionRntComponent implements OnInit {

	dataTabla: DatoPaginadoModel;
	headerAccionRnt: Array<string>;
	formAccionRnt: FormGroup;
	selectAccionRnt: any;

	paginaActual: number;
	// filtros
	filtro: FormGroup;
	public isCollapsed = true;

	// Selects
	tipoUsuario: Array<any> = [];
	tipoPrestador: Array<any> = [];
	accionRNT: Array<any> = [];
	estadoRNT: Array<EstadosRNTEntry> = [];
	tipoSolicitud: Array<TipoSolicitudEntry> = [];
	estadoSolicitud: Array<EstadoSolicitudEntry> = [];

	constructor(private formBuilder: FormBuilder, private accionRntService: AccionRntService, private modalService: NgbModal) {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;

		this.createForm();
		this.selectAccionRnt = null;
		this.paginaActual = 1;

	}

	ngOnInit() {
		this.headerAccionRnt = ['Tipo de usuario', 'Tipo de prestador', 'Descripción',
			'Estado RNT', 'Tipo de solicitud', 'Estado solicitud', 'Ruta URL', 'Estado', 'Acción'];
		this.consultarListas();
		this.onConsultarAccionRnt(1);
	}

	createForm() {
		this.formAccionRnt = this.formBuilder.group({
			// tipo_usuario_id: [null, Validators.required],
			tipo_prestador_id: [null, Validators.required],
			descripcion: [null, Validators.required],
			estado_rnt_id: [null, Validators.required],
			tipo_solicitud_id: [null, Validators.required],
			estado_solicitud_id: [null, Validators.required],
			ruta_url: [null, Validators.required],
			activo: [true],
		});

		this.filtro = this.formBuilder.group({
			// tipo_usuario_id: [null],
			tipo_prestador_id: [null],
			descripcion: [null],
			estado_rnt_id: [null],
			tipo_solicitud_id: [null],
			estado_solicitud_id: [null],
			ruta_url: [null],
			activo: [null],
		});
	}

	onConsultarAccionRnt(page: number) {
		this.accionRntService.get({ ...this.filtro.value, numeroPagina: page })
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
				}
			});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarAccionRnt(value);
	}

	onAgregarAccionRnt() {

		this.accionRntService.create({
			...this.formAccionRnt.value, activo: 1,
			tipo_usuario_id: 5
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarAccionRnt(this.paginaActual);
					this.formAccionRnt.reset();
				}
			});
	}

	onOperarAccionRnt() {
		if (!this.selectAccionRnt) {
			this.onAgregarAccionRnt();
		} else {
			this.onModificarAccionRnt();
		}
	}

	onCargarAccionRnt(entry: any) {
		entry.activo = entry.activo ? 1 : 0;
		this.formAccionRnt.patchValue({
			...entry,
		});

		this.selectAccionRnt = entry;
	}

	onEliminarAccionRnt(entry: any) {
		const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		const confirmarRespuesta = {} as ConfirmarRespuestaModel;
		confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
		confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
		modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
		modalRef.result.then(() => {
			this.accionRntService.delete(entry).subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarAccionRnt(this.paginaActual);
					this.selectAccionRnt = null;
					this.formAccionRnt.reset();
				}
			});
		});
	}

	onModificarAccionRnt() {
		this.accionRntService.update({
			...this.formAccionRnt.value,
			accion_rnt_id: this.selectAccionRnt.accion_rnt_id,
			tipo_usuario_id: 5
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarAccionRnt(this.paginaActual);
					this.formAccionRnt.reset();
					this.selectAccionRnt = null;
				}
			});
	}

	consultarListas() {
		this.accionRntService.getTipoUsuario().subscribe(resultado => {
			if (resultado.data) {
				this.tipoUsuario = resultado.data;
			}
		});

		this.accionRntService.getTipoPrestador().subscribe(resultado => {
			if (resultado.result) {
				this.tipoPrestador = resultado.data;
			}
		});

		this.accionRntService.getEstadosRNT().subscribe(resultado => {
			if (resultado.result) {
				this.estadoRNT = resultado.data;
			}
		});

		this.accionRntService.getTipoSolicitud().subscribe(resultado => {
			if (resultado.result) {
				this.tipoSolicitud = resultado.data;
			}
		});

		this.accionRntService.getEstadoSolicitud().subscribe(resultado => {
			if (resultado.result) {
				this.estadoSolicitud = resultado.data;
			}
		});
	}

	filtrar() {
		this.paginaActual = 1;
		this.onConsultarAccionRnt(1);
	}

	limpiar() {
		this.filtro.reset();
		this.filtrar();
	}
	limpiarAcciones() {
		this.formAccionRnt.reset();
		this.selectAccionRnt = null;
		this.createForm();

	}
}
